<template>
    <div id="myDateShow">
        <div class="title">{{orderId!=null?"编辑":"新增"}}采集单信息</div>
        <div id="dataShow">
            <div class="line">
                <div class="key">采集商</div>
                <div class="value">{{order.collectorName}}</div>
                <div class="value">
                    <el-button type="success" size="small" @click="showQueryCollector">查看</el-button>
                    <el-dialog title="查询采集商" :visible.sync="dialogCollector">
                        <el-form>
                            <div class="line">
                                <div class="key">采集商</div>
                                <div class="value"><el-input  v-model="queryCollectorName"  placeholder="请输入采集商名称" size="50"></el-input></div>
                                <div class="value"><el-button type="success" size="small" @click="queryCollector(queryCollectorName)">搜索</el-button></div>
                            </div>
                            <div class="line">
                                <el-table
                                        ref="singleTable"
                                        :data="queryCollectorData"
                                        highlight-current-row
                                        style="width: 100%"
                                        @current-change="changeCollector">
                                    <el-table-column
                                            prop="name"
                                            label="采集商"
                                            width="180">
                                    </el-table-column>
                                    <el-table-column
                                            prop="username"
                                            label="采集员"
                                            width="180">
                                    </el-table-column>
                                    <el-table-column
                                            prop="phone"
                                            label="联系方式"
                                            width="180">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogCollector = false">取 消</el-button>
                            <el-button type="primary" @click="sureQueryResult('Collector')">确 定</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <div class="line">
                <div class="key">款项支付</div>
                <div class="value">
                    <el-select class="w500" v-model="order.payType" placeholder="请选择款项支付">
                        <el-option
                                v-for="item in paymentTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line">
                <div class="key">采集商品</div>
                <div class="value">{{order.commodityName}}</div>
                <div class="value">
                    <el-button type="success" size="small" @click="showCommodity">查看</el-button>
                    <el-dialog title="查询采集商品" :visible.sync="dialogCommodity">
                        <el-form>
                            <div class="line">
                                <div class="key">商品名称</div>
                                <div class="value"><el-input  v-model="queryCommodityName"  placeholder="请输入采集商品名称" size="50"></el-input></div>
                                <div class="value"><el-button type="success" size="small" @click="queryCommodity(queryCommodityName)">搜索</el-button></div>
                            </div>
                            <div class="line">
                                <el-table
                                        ref="singleTable"
                                        :data="queryCommodityData"
                                        highlight-current-row
                                        style="width: 100%"
                                        @current-change="changeCommodity">
                                    <el-table-column
                                            prop="skuName"
                                            label="商品名称"
                                            width="180">
                                    </el-table-column>
                                    <el-table-column
                                            prop="skuPrice"
                                            label="单价"
                                            width="180">
                                    </el-table-column>
                                    <el-table-column
                                            prop="skuWeight"
                                            label="规则"
                                            width="180">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogCommodity = false">取 消</el-button>
                            <el-button type="primary" @click="sureQueryResult('Commodity')">确 定</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <div class="line">
                <div class="key">集采总重量</div>
                <div class="value">
                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" class="w500" @input="calculate" v-model="order.totalWeight" maxlength="10" show-word-limit placeholder="请填写集采总重量*斤"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">集采金额</div>
                <div class="value">
                    <el-input  v-model="order.amount" :disabled="true"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">采集合同</div>
                <div class="value">
                    <el-upload
                            :headers="headers"
                            ref="upLoad"
                            :on-change="upLoad"
                            :on-success="upLoadSeccess"
                            :on-remove="removeUpload"
                            :limit="5"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.CollectorContract"
                            :file-list="contractFiles"
                            :action="baseURL+'/collection/upload'"
                            :before-remove="removecontractFiles"
                            :auto-upload="false">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">此集采合同均为平台和农户签订的合同、平台和集采商签订的合同</div>
                    </el-upload>
                </div>
            </div>
            <div class="line">
                <div class="key">运费</div>
                <div class="value">
                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" class="w500"  v-model="order.freight" maxlength="5" show-word-limit placeholder="请填写运费"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">收货人</div>
                <div class="value">
                    <el-input class="w500" v-model="order.receiptName" maxlength="10" show-word-limit placeholder="请填写收货人"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">收货人手机号码</div>
                <div class="value">
                    <el-input class="w500" v-model="order.receiptPhone"  maxlength="11" show-word-limit placeholder="请填写收货人手机号码"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">收货地址</div>
                <div class="value">
                    <el-input class="w500" v-model="order.receiptAddress" maxlength="100" show-word-limit placeholder="请填写收货地址"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <el-button type="primary" size="medium" @click="submit">保存</el-button>
                </div>
            </div>
        </div>
        <div class="but">
            <el-button type="danger" size="small" @click="backClick">返回</el-button>
        </div>
        <el-dialog title="发送短信" :visible.sync="dialogSendSms">
            <div style="display: grid;justify-content: center">
                <div style="display: flex;justify-content: center;color: #2894FF;font-size: 16px;margin-bottom: 15px;">
                    <i class="el-icon-success"></i>
                    <div>集采订单已经创建成功！</div>
                </div>
                <div style="margin-bottom: 20px;">备注：
                    集采订单创建成功后，须向集采商发送手机短信确认唯一辨识码的真实性，方便集采！ 请进行以下操作！</div>
                <div style="margin-bottom: 15px;">唯一辨识码</div>
                <div style="color: red;text-align: center;border: 1px solid black;height: 30px;line-height: 30px;margin-bottom: 20px;">{{this.queryOrder.verifyCode}}</div>
                <div>发至手机号码：{{this.queryOrder.collectorPhone}}</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sendSmsMsg()">确认发送</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { queryCollectorByName,getSkuInfoListByClassifyIdAndName,addOrUpdateCentralizedPurchaseOrder,sendSmsMsg,queryCentralizedPurchaseOrderById,newVue} from "../../network/collector";

    export default {
        name: "CollectorOrderInsert",
        data(){
            return{
                orderId:null,//订单ID
                order:{},//订单
                queryOrder:{},//订单
                dialogCollector: false,//是否展示对话框
                dialogCommodity: false,//是否展示对话框
                dialogSendSms:false,//发送短信
                baseURL:newVue.baseURL,//請求地址
                paymentTypeOptions:[
                    {
                    value:"WeiXin",
                    label:"微信小程序"
                },
                    {
                        value:"WeiXinPublicAccount",
                        label:"微信小程序预付+公帐转款"
                    },
                    {
                        value:"PublicAccount",
                        label:"公帐"
                    },
                ],
                headers: {
                },
                queryCollectorData: [],//搜索到的采集员信息
                queryCommodityData:[],//搜索到的采集商品
                uploadParam:{
                    CollectorContract:{type:"CollectorContract"},
                },
                queryCollectorName:null,
                queryCommodityName:null,
                selectCommodity:{},
                contractFiles:[],//合同文件
                uploaditem:{},
            }
        },
        created() {
            newVue.obj = this;
            this.authorization=newVue.obj.common.loginInfo.jwtToken;
            this.headers.Authorization = this.authorization;
            this.common.HeaderLocationTwo.href = "/collector/orderList";``
            this.common.HeaderLocationTwo.name = "采集单管理";
            this.common.HeaderLocationThree.name = "新增采集单";
            if (this.$route.params.id!=null){
                this.orderId = this.$route.params.id;
                this.common.HeaderLocationThree.name = "编辑采集单";
                this.queryOrderData(this.orderId,"update");
            }
        },
        methods: {
            backClick(){
                this.$router.push("../OrderList");
            },
            upLoadSeccess(res){},
            //上传营业执照图片
            upLoad (file, fileList) {this.$refs.upLoad.submit();},
            removeUpload(file,fileList){
                this.contractFiles = fileList;
            },
            removecontractFiles(file, fileList){//删除合同文件
                this.contractFiles = [];
                if (fileList.length > 0){
                    for (let i = 0; i < fileList.length; i++) {
                        let item = {};
                        item["name"] = file.name;
                        item["id"] = file.uid;
                        item["fileSize"] = file.raw.size;
                        item["fileType"] = file.raw.type;
                        item["associationType"] = "CollectorContract";
                        this.contractFiles.push(item);
                    }
                }else {
                    this.contractFiles = [];
                }

            },
            //提交表单
            submit(){
                let files = [];
                for (let i = 0; i < this.contractFiles.length; i++) {
                    let file = {};
                    file["name"] = this.contractFiles[i].name;
                    file["id"] = this.contractFiles[i].uid;
                    file["fileSize"] = this.contractFiles[i].raw.size;
                    file["fileType"] = this.contractFiles[i].raw.type;
                    file["associationType"] = "CollectorContract";
                    files.push(file);
                }
                this.order["contractFiles"] = files;
                addOrUpdateCentralizedPurchaseOrder(this.order).then(res => {
                    if (res.code == "200"){
                        this.queryOrderData(res.data,"Add");
                    }
                })
            },
            showQueryCollector(){
                this.dialogCollector = true;
            },
            queryCollector(collectorName){//查询采集商
                queryCollectorByName(collectorName).then(res => {
                    if (res.code == "200"){
                        this.queryCollectorData = [];
                        this.queryCollectorData.push(res.data);

                    }
                })
            },
            showCommodity(){
                this.dialogCommodity = true;
            },
            queryCommodity(commodityName){//查询采集商品
                getSkuInfoListByClassifyIdAndName("3",commodityName).then(res => {
                    if (res.code == "200"){
                        this.queryCommodityData = [];
                        this.queryCommodityData = res.data.list;
                    }
                })
            },
            changeCommodity(val){//选择绑定商品
                this.order.commodityName = val.skuName;
                this.order.commodityId = val.id;
                this.selectCommodity = val;
            },
            changeCollector(val){//选择绑定采集商
                this.order.collectorName = val.name;
                this.order.collectorId = val.id;
            },
            sureQueryResult(type){//确认 查询结果
                if (type == "Collector"){
                    if (this.order.collectorId == null){
                        this.$confirm('请选择采集商', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                        return;
                    }

                }else if (type == "Commodity"){
                    if (this.order.commodityId == null){
                        this.$confirm('请选择采集商品', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                        return;
                    }

                }
                this.dialogCollector = false;
                this.dialogCommodity = false;
            },
            calculate(){
                if (this.selectCommodity.id == null){
                    this.$confirm('请绑定采集商品', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    return;
                }
                this.order.amount = this.selectCommodity.skuPrice * this.order.totalWeight;
            },
            queryOrderData(id,status){//查询采集单
                queryCentralizedPurchaseOrderById(id).then(res => {
                    if (res.code == "200"){
                        if (status == "Add"){
                            this.queryOrder = res.data;
                            this.dialogSendSms = true;
                        }else {
                            this.order = res.data;
                            this.contractFiles = res.data.contractFiles;
                        }

                    }
                })
            },
            sendSmsMsg(){//发送采集单的验证码给采集员
                let map = {
                    orderid:this.queryOrder.id.substring(this.queryOrder.id.length -4,this.queryOrder.id.length),
                    code:this.queryOrder.verifyCode
                };
                sendSmsMsg(this.queryOrder.collectorPhone,"SMS_243955764",JSON.stringify(map)).then(res => {
                    if (res.code == "200"){
                        this.dialogSendSms = false;
                        this.$message({
                            message: '短信发送成功',
                            type: 'success'
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped>
    @import "../../assets/css/data.css";
    .w500{
        width: 500px;
    }
</style>
